import { render, staticRenderFns } from "./SwipeFileCard.vue?vue&type=template&id=46875778&scoped=true"
import script from "./SwipeFileCard.vue?vue&type=script&lang=js"
export * from "./SwipeFileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46875778",
  null
  
)

export default component.exports